import { CardType } from './card-type.enum';

export class LoanCard {
    name: string;
    cardType: CardType;
    headerText: string;
    infoText: string;
    merchantName: string;
    loanAmount: number;
    tenure: number;
    emi: number;
    progressMsg: string;
    scale: number;
    cardInfo: string;
    eventName: string;
    eventWithCustomProps: any;
    constructor(
        name: string,
        cardType: CardType,
        headerText: string,
        infoText: string = '',
        merchantName: string = '',
        loanAmount: number = 0,
        tenure: number = 0,
        emi: number = 0,
        progressMsg: string = '',
        scale: number = 0,
        cardInfo: string = '',
        eventName: string = '',
        eventWithCustomProps = {} ) {
        this.name = name;
        this.cardType = cardType;
        this.headerText = headerText;
        this.infoText = infoText;
        this.merchantName = merchantName;
        this.loanAmount = loanAmount;
        this.tenure = tenure;
        this.emi = emi;
        this.progressMsg = progressMsg;
        this.scale = scale;
        this.cardInfo = cardInfo;
        this.eventName = eventName;
        this.eventWithCustomProps = eventWithCustomProps;
    }
}
